<template>
  <!--h4 class="text-success text-center">Api integrated</h4-->

  <CardLoader v-if="loading" class="my-3" />
  <CardLoader v-if="loading" class="my-3" />


  <div class="w-100" v-else>
    <div class="min-vh-100 bg-light d-flex">
      <div class="flex-fill px-4">
        <div class="mb-3">
          <GoBackButton />
        </div>

        <!-- Search Bar -->
        <div class="d-flex justify-content-end mb-3">
          <input v-model="searchQuery" type="text" class="form-control w-25" placeholder="Search skill..."
            @keyup.enter="fetchSkills" />
          <button class="btn btn-success ms-2" @click="fetchSkills">Search</button>
        </div>

        <div v-if="!loading && skills.length === 0" class="text-center py-5 d-flex align-items-center justify-content-center flex-column" style="min-height: 300px;">
          <NoDataFound />
        </div>

        <!-- Skills Rows -->
        <div class="skills-container" v-else>
          <div v-for="skill in skills" :key="skill.id" class="skill-row mb-5">
            <!-- Skill Header -->
            <div class="card mb-3">
              <div class="card-header bg-success text-white">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 class="text-white h5 mb-1">{{ skill.name }}</h3>
                    <p class="mb-0 small opacity-75">{{ skill.description }}</p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <!-- <a :href="'/skills/edit/' + locationId" class="border border-1 boder-white badge">
                      Edit
                    </a>   -->
                    <MaterialBadge :color="skill.status === 'Active' ? 'success' : 'danger'" class="shadow-sm">
                      Status: {{ skill.status }}
                    </MaterialBadge>
                  </div>
                </div>
              </div>
            </div>

            <!-- Skill Content Grid -->
            <div class="row g-3">
              <!-- Volunteers Column -->
              <div class="col-lg-4">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Volunteers</h5>
                    <span class="badge bg-success">{{
                      skill.volunteers.length
                    }}
                      Active</span>
                  </div>
                  <div class="card-body">
                    <div v-if="skill.volunteers.length === 0" class="text-center py-4">
                      <div class="text-muted">
                        <i class="fas fa-users fa-2x mb-3"></i>
                        <p class="mb-0">No volunteers assigned</p>
                      </div>
                    </div>
                    <div v-else class="d-flex flex-column gap-2" style="max-height: 300px; overflow-y: auto">
                      <div v-for="volunteer in skill.volunteers" :key="volunteer.id"
                        class="d-flex align-items-center gap-3 p-2 border rounded hover-shadow cursor-pointer"
                        @click="selectVolunteer(volunteer)">
                        <div class="rounded text-white small fw-bold d-flex align-items-center justify-content-center"
                          :style="{
                            backgroundColor: volunteer.avatarColor,
                            width: '32px',
                            height: '32px',
                          }">
                          {{ volunteer.initials }}
                        </div>
                        <div class="flex-fill">
                          <div class="fw-medium text-dark">
                            {{ volunteer.name }}
                          </div>
                          <div class="small text-muted">
                            {{ volunteer.email }}
                          </div>
                        </div>
                        <span class="rounded-circle" :style="{
                          backgroundColor: '#10b981',
                          width: '8px',
                          height: '8px',
                        }"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Activities Column -->
              <div class="col-lg-4">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Activities</h5>
                    <span class="badge bg-info">{{
                      skill.activities.length
                    }}
                      Active</span>
                  </div>
                  <div class="card-body">
                    <div v-if="skill.activities.length === 0" class="text-center py-4">
                      <div class="text-muted">
                        <i class="fas fa-calendar fa-2x mb-3"></i>
                        <p class="mb-0">No activities scheduled</p>
                      </div>
                    </div>
                    <div v-else class="d-flex flex-column gap-3">
                      <div v-for="activity in skill.activities" :key="activity.id" class="border rounded p-3" :style="{
                        borderLeftColor: activity.borderColor,
                        borderLeftWidth: '4px',
                      }">
                        <div class="d-flex align-items-center gap-4 mb-2">
                          <i class="material-icons text-info">pending_actions</i>
                          <div class="fw-medium text-dark mb-0">
                            {{ activity.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Interested Users Column -->
              <div class="col-lg-4">
                <div class="card h-100">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Interested Users</h5>
                    <span class="badge bg-warning">{{
                      skill.interestedUsers.length
                    }}
                      Pending</span>
                  </div>
                  <div class="card-body">
                    <div v-if="skill.interestedUsers.length === 0" class="text-center py-4">
                      <div class="text-muted">
                        <i class="fas fa-clipboard fa-2x mb-3"></i>
                        <p class="fw-medium mb-1">No pending applications</p>
                        <p class="small mb-0">
                          New applications will appear here
                        </p>
                      </div>
                    </div>
                    <div v-else class="d-flex flex-column gap-2">
                      <div v-for="user in skill.interestedUsers" :key="user.id" class="border rounded p-3 hover-shadow">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <div class="d-flex align-items-center gap-2">
                            <div
                              class="rounded text-white small fw-bold d-flex align-items-center justify-content-center"
                              :style="{
                                backgroundColor: user.avatarColor,
                                width: '24px',
                                height: '24px',
                              }">
                              {{ user.initials }}
                            </div>
                            <span class="fw-medium text-dark">{{
                              user.name
                            }}</span>
                          </div>
                          <button class="btn btn-success btn-sm" @click="approveUser(user, skill)">
                            Approve
                          </button>
                        </div>
                        <div class="small text-muted">{{ user.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination Footer -->
    <div class="px-4 py-2">
      <PaginationFooter :pagination="pagination" @changePage="loadPage" @updatePageSize="updatePageSize" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import GoBackButton from "../../components/common/GoBackButton.vue";
import PaginationFooter from "../../components/PageLayout/PaginationFooter.vue";
import { getLocationId } from "../../utils/SessionDataHandler";
import CardLoader from "../../components/Loader/CardLoader.vue";
import NoDataFound from "../../components/NoDataFound.vue";
import MaterialBadge from "../../components/common/MaterialBadge.vue";

const store = useStore();
const locationId = getLocationId();
const loading = ref(false);

const currentPage = ref(1);
const perPage = ref(10);
const searchQuery = ref("");
const pagination = computed(() => store.getters.pagination);
const skills = computed(() => store.getters.summarySkills);
// const skills = '';
const fetchSkills = async () => {
  try {
    await store.dispatch("getSkillsSummary", {
      locationId,
      search: searchQuery.value,
      pageNumber: currentPage.value,
      pageSize: perPage.value,
    });
  } catch (err) {
    console.error("Error loading skills:", err);
  }
};

/**
 * ✅ Load a specific page
 */
const loadPage = async (page) => {
  if (!page) return;
  currentPage.value = page;
  await fetchSkills();
};

/**
 * ✅ Update page size and reset to page 1
 */
const updatePageSize = async (size) => {
  perPage.value = size;
  currentPage.value = 1;
  await fetchSkills();
};

const selectVolunteer = (volunteer) => {
  console.log("Selected Volunteer:", volunteer);
};

const approveUser = (user, skill) => {
  const newVolunteer = {
    id: `VOL${String(Date.now()).slice(-3)}`,
    name: user.name,
    email: user.email,
    initials: user.initials,
    avatarColor: user.avatarColor,
    statusColor: "#10b981",
  };
  skill.volunteers.push(newVolunteer);
  const index = skill.interestedUsers.findIndex((u) => u.id === user.id);
  if (index > -1) skill.interestedUsers.splice(index, 1);
};

onMounted(async () => {
  loading.value = true;
  try {
    await fetchSkills();
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.hover-shadow:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.skill-row {
  border-left: 4px solid #6f42c1;
  padding-left: 1rem;
}
</style>
